export default {
	colors: {
		color1: '#0072ac',
		color2: '#bd1d83',
		textColor: '#184377'
	},
	fastFacts: [
		{
			id: 1,
			title: "Make That Money!",
			content: '<p>Your first paycheck with IDSI will be after two full pay periods. Pay dates are on the 15th and the last day of each month. If those dates fall on a weekend or holiday, you will be paid the weekday beforehand..</p>',
			icon: "pay.sherlock"
		},{
			id: 2,
			title: "Record Your Time!",
			content: '<p>Use Deltek to track your time and request paid time off. Submit your hours daily, and sign your timesheet at the end of each pay period.</p><p><a href="https://timesheet.idsi.com/" target="_blank" rel="noopener noreferrer">Deltek</a></p>',
			icon: "pay.gandalf"
		},{
			id: 3,
			title: "Check Your Deets!",
			content: '<p>Pay stubs, tax statements, and retirement savings can be viewed online through ADP.</p><p>It\'s your job to ensure your tax information is correct, so stay on top of it!</p><p><a href="https://my.adp.com" target="_blank" rel="noopener noreferrer">ADP</a></p>',
			icon: "pay.rex"
		},{
			id: 4,
			title: "Hit the Road!",
			content: '<p>If you\'re asked to travel, you will need to complete an expense authorization before you travel.</p><p>Check with your supervisor for authorization codes. When you get back, you will need to submit an expense report.</p><p>Not sure how to do all that?  Don’t worry – we\'ll show you!</p><p><a href="https://www.youtube.com/watch?v=BDyNjhuBruA" target="_blank" rel="noopener noreferrer">Expense Report Tutorial</a></p>',
			icon: "pay.hobo"
		}
	],
	faq: [
		{
			id: 1,
			side1: "Where do I go to request leave?",
			side2: '<p>Create an appointment in Outlook for your PTO request, and invite your supervisor and/or project manager(s). They will approve your leave request!</p>',
			icon: "pay.clown"
		},{
			id: 2,
			side1: "How do I report vacation time on my timesheet?",
			side2: '<p>Your pre-approved vacation time will be highlighted on your timesheet. Create a new timesheet line, click the project field, then the magnifying glass. Click the plus next to INDIRECT, then the plus next to Leave, then click "Paid Time Off”, and finally click the “Select” button.</p>',
			icon: "pay.bowie"
		},{
			id: 3,
			side1: "How do I correct my timesheet after it has been submitted?",
			side2: '<p>If the status in the upper right is not listed as “Processed”, you can make any necessary changes and submit it again.  Otherwise, contact your supervisor, and he/she will alert the correct person to reopen your timesheet so you can make adjustments.</p>',
			icon: "pay.diver"
		},{
			id: 4,
			side1: "How do I change my contribution to my retirement plan?",
			side2: '<p>Go to the retirement section in your ADP account. There should be a summary on your retirement income section with a link to increase your contribution. For more information on your retirement plan, check out our <a href="/onboarding/perks-for-the-people#Retirement">Perks for the People</a> page!</p>',
			icon: "pay.mamaSan"
		},{
			id: 5,
			side1: "Where do I go to get my W-2 tax form?",
			side2: '<p>Go to the pay section in your ADP account. There should be a tax statements section where you can click on the tax year to download your IDSI W-2 statement.</p>',
			icon: "pay.colonist"
		},{
			id: 6,
			side1: "How do I change my direct deposit bank information?",
			side2: '<p>Download the Direct Deposit Form from the <a href="#Payroll">Payroll and Tax Forms</a> section, and follow the instructions listed.</p>',
			icon: "pay.pirate"
		},{
			id: 7,
			side1: "When is my pay stub available to view on ADP?",
			side2: '<p>It is available on your pay day.</p>',
			icon: "pay.benny"
		},{
			id: 8,
			side1: "Where do I go to see how much vacation time I have left?",
			side2: '<p>You are responsible for keeping track of the PTO tracker you receive from HR. For more information on PTO, check out our <a href="/onboarding/perks-for-the-people#PaidTimeOff">Perks for the People</a> page!</p>',
			icon: "pay.opera"
		}
	],
	docs: [
		{
			id: 1,
			title: "Federal Withholding Form",
			link: "assets/docs/Federal-Withholding-Form.pdf"
		},
		{
			id: 2,
			title: "State Withholdings Form",
			link: "assets/docs/State-Withholding-Form.pdf"
		},
		{
			id: 3,
			title: "Direct Deposit Form",
			link: "assets/docs/Direct-Deposit-Form.pdf"
		},
		{
			id: 4,
			title: "W2 and 1099 Request Form",
			link: "assets/docs/I-9-Form.pdf"
		}
	]
};



// WEBPACK FOOTER //
// ./src/data/Pay.js